import { computed } from 'mobx';
import { getAllOptions, OptionWithPath } from 'owa-options-store';
import * as Fuse from 'fuse.js';
import strings from 'owa-strings/owa-options-strings';

export interface OptionSearchEntry {
    searchTerm: string;
    option: OptionWithPath;
}

const searchModel = computed(() => {
    const searchTerms: OptionSearchEntry[] = getAllOptions().map(option => ({
        searchTerm:
            (strings[option.searchTermsStringKey] as string) ||
            (strings[option.titleStringKey] as string) ||
            '',
        option: option,
    }));

    const maxLength = searchTerms.reduce(
        (max, searchTerm) => Math.max(max, searchTerm.searchTerm.length),
        0
    );

    return new Fuse(searchTerms, {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: maxLength,
        maxPatternLength: 50,
        tokenize: true,
        keys: ['searchTerm'],
    });
});

export default () => searchModel.get();
